// import { useTabletAndBelowMediaQuery } from 'layout'
// import { Pagination } from 'semantic-ui-react'
import React from 'react'
import styled from 'styled-components'
import { CaretLeft, CaretRight } from 'phosphor-react'
import { Pagination } from 'antd'

// export const PaginationComponent = ({ pageChanged, totalCount, activePage, pageSize }) => {
//     const isMobile = useTabletAndBelowMediaQuery()
//     return (
//         <Pagination
//             activePage={activePage}
//             onPageChange={(_, { activePage }) => pageChanged(activePage)}
//             totalPages={Math.ceil(totalCount / pageSize)}
//             size={isMobile ? "mini" : "large"}
//             firstItem={!isMobile ? undefined : null}
//             lastItem={!isMobile ? undefined : null}
//         />
//     )
// }

const PaginationContainer = styled.div`
  display: flex;
  justify-content: right;
  padding: 10px;
  background: #fff;
`

const StyledPagination = styled(Pagination)`
  .ant-pagination-item {
    background: transparent;
    border-radius: 4px;
    font-weight: 500;
    color: #a0a0a0;
  }

  .ant-pagination-item-active {
    background: #2454ff !important;
    border-color: #2454ff !important;
    color: white !important;
  }

  .ant-pagination-item:hover {
    border-color: #2454ff;
  }

  .ant-pagination-prev,
  .ant-pagination-next {
    color: #a0a0a0;
  }

  .ant-pagination-prev:hover,
  .ant-pagination-next:hover {
    color: #2454ff;
  }
`

export const CustomPagination = ({ totalPages, currentPage, onPageChange }) => {
  return (
    <PaginationContainer>
      <StyledPagination
        current={currentPage}
        total={totalPages * 10}
        pageSize={10}
        showSizeChanger={false}
        onChange={onPageChange}
        prevIcon={<CaretLeft size={16} />}
        nextIcon={<CaretRight size={16} />}
      />
    </PaginationContainer>
  )
}
